export const CHECKLIST_TYPES = {
  DAILY_AM_STILLS: 'dailyAmStills',
  DAILY_PM_STILLS: 'dailyPmStills',
  DAILY_AM_MASH: 'dailyAmMash',
  DAILY_PM_MASH: 'dailyPmMash',
  WEEKLY_STILLS: 'weeklyStills',
  WEEKLY_MASH: 'weeklyMash'
};
